<template>
	<div id="review-and-evaluate">
		<!-- Challenger Start Screen -->
		<div v-if="!challengerRunning && !challengerSuccessful" class="initiate-challenge">
			<challengerInitiate 
				:challengerProfile="challengerProfile"
				:activeTenantId="activeTenantId"
				:challengerTenantId="challengerTenantId"
				@deploy="onDeploy"
			/>
		</div>

		<!-- Challenger Results -->
		<div v-else-if="challengerSuccessful" class="challenger-complete">
			<challengerResults
				:challengerProfile="challengerProfile"
			/>
		</div>

		<!-- Challenger Progress Bar -->
		<div v-else class="challenger-in-progress">
			<challengerProgress
				:challengerProfile="challengerProfile"
			/>
		</div>
	</div>
</template>

<script>
	/**
	 * @fileoverview review-and-evaluate.vue is the last step of four in the Configuration Explorer.
	 * This step contains the Champion Challenger. It relies on vuex to map the state variables from the store files.
	 * 
	 * @components
	 * 		challengerInitiate - first step of the Champion Challenger
	 *		challengerProgress - second step of the Champion Challenger
	 * 		challegnerResults - third step of the Champion Challenger
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import { mapState } from "vuex";
	import challengerInitiate from '@/components/configuration-explorer/champion-challenger/challenger-initiate.vue';
	import challengerProgress from '@/components/configuration-explorer/champion-challenger/challenger-progress.vue';
	import challengerResults from '@/components/configuration-explorer/champion-challenger/challenger-results.vue';

	export default {
		name: "reviewAndEvaluate",
		data() {
			return {
			};
		},
		components: {
			challengerInitiate,
			challengerProgress,
			challengerResults
		},
		computed: {
			...mapState({
				challengerProfile: (state) => state.config.challengerProfile,
				activeTenantId: (state) => state.account.activeTenantId,
				challengerRunning: (state) => state.config.challengerRunning,
				challengerReportId: (state) => state.config.challengerReportId,
				challengerSuccessful: (state) => state.config.challengerSuccessful,
				challengerTenantId: (state) => state.config.challengerTenantId
			}),
		},
		/**
		 * Mounted lifecycle hook
		 * If the challenger successfully completes, retrieve the results 
		 */
		mounted() {
			let payload = {
				tenantId: this.activeTenantId,
				reportId: this.challengerReportId
			};

			if (this.activeTenantId === 'master') {
				payload.tenantId = this.challengerTenantId;
			}

			if (this.challengerSuccessful) {
				this.$store.dispatch("retrieveChallengerResultList", payload);
			}
		},
		watch: {
			/**
			 * When a report Id is generated, continuously check the challenger status
			 */
			async challengerReportId() {
				let statusPayload = {
					tenantId: this.activeTenantId,
					reportId: this.challengerReportId
				};

				if (this.activeTenantId === 'master') {
					statusPayload.tenantId = this.challengerTenantId;
				}
				
				if (this.challengerReportId !== "") {
					let timer = setInterval(async () => await this.$store.dispatch("retrieveChallengerStatus", statusPayload), 1000);
					this.$store.dispatch('setChallengerStatusTimer', timer);
				}
			},
			/**
			 * When the challenger successfully completes, retrieve the results
			 */
			challengerSuccessful() {
				let payload = {
					tenantId: this.activeTenantId,
					reportId: this.challengerReportId
				};

				if (this.activeTenantId === 'master') {
					payload.tenantId = this.challengerTenantId;
				}

				if (this.challengerSuccessful) {
					this.$store.dispatch("retrieveChallengerResultList", payload);
				}
			},
		},
		methods: {
			/**
			 * Emit that a deploy occurred to the parent
			 */
			onDeploy() {
				this.$emit("deploy");
			},
		},
	};
</script>

<!-- Styles defined in _review-and-evaluate.scss -->
